<template>
  <div class="axd-wrapper">
    <div class="axd-header">
      <div class="axd-header__title">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <rect
            x="2"
            y="3"
            width="20"
            height="8"
            rx="2"
            stroke="#0284C7"
            stroke-width="2"
            fill="none"
          />
          <rect
            x="2"
            y="13"
            width="20"
            height="8"
            rx="2"
            stroke="#0284C7"
            stroke-width="2"
            fill="none"
          />
          <line
            x1="6"
            y1="7"
            x2="6"
            y2="7"
            stroke="#0284C7"
            stroke-width="2"
            stroke-linecap="round"
          />
          <line
            x1="6"
            y1="17"
            x2="6"
            y2="17"
            stroke="#0284C7"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
        Almacenamiento · Cámaras Axis
      </div>

      <button
        class="axr-btn axr-btn--secondary"
        @click="showGlobalRetention = true"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
          <rect
            x="3"
            y="4"
            width="18"
            height="18"
            rx="2"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
          />
          <line
            x1="3"
            y1="9"
            x2="21"
            y2="9"
            stroke="currentColor"
            stroke-width="2"
          />
          <line
            x1="8"
            y1="2"
            x2="8"
            y2="6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
          <line
            x1="16"
            y1="2"
            x2="16"
            y2="6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
        Reglas de retención
      </button>

      <div class="axd-header__stats">
        <div class="axd-stat">
          <span class="axd-stat__value">{{ cameras.length }}</span>
          <span class="axd-stat__label">Cámaras</span>
        </div>
        <div class="axd-stat axd-stat--warning" v-if="unreachableCount > 0">
          <span class="axd-stat__value">{{ unreachableCount }}</span>
          <span class="axd-stat__label">No disponibles</span>
        </div>
      </div>
    </div>

    <div class="axd-body" v-loading="isLoading">
      <div v-if="!isLoading && cameras.length === 0" class="axd-empty">
        Todavía no hay datos de disco disponibles para las cámaras Axis.
      </div>

      <div class="axd-grid">
        <AxisCameraCard
          v-for="camera in cameras"
          :key="camera.recorderIdentifier"
          :camera="camera"
          :refreshing="refreshingId === camera.recorderIdentifier"
          @refresh="onRefresh"
        />
      </div>
    </div>

    <AxisRetentionGlobalDialog
      :visible="showGlobalRetention"
      @close="showGlobalRetention = false"
    />
  </div>
</template>

<script>
import AxisCameraCard from "./AxisCameraCard.vue";
import AxisRetentionGlobalDialog from "./AxisRetentionGlobalDialog.vue";
import { loadAxisDiskStatus, refreshAxisCamera } from "@/services/axis.api";

export default {
  name: "AxisDiskStatusView",
  components: { AxisCameraCard, AxisRetentionGlobalDialog },
  data() {
    return {
      cameras: [],
      isLoading: false,
      refreshingId: null,
      showGlobalRetention: false,
    };
  },
  computed: {
    unreachableCount() {
      return this.cameras.filter((c) => !c.isCameraReachable).length;
    },
  },
  async created() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        this.cameras = await loadAxisDiskStatus();
      } catch (e) {
        console.error("Error cargando estado de discos Axis:", e);
        this.$message.error(
          "No se pudo cargar el estado de disco de las cámaras Axis."
        );
      } finally {
        this.isLoading = false;
      }
    },
    async onRefresh(identifier) {
      this.refreshingId = identifier;
      try {
        await refreshAxisCamera(identifier);
        await this.loadData();
        this.$message.success(`Cámara ${identifier} actualizada`);
      } catch (e) {
        console.error("Error refrescando cámara:", identifier, e);
        if (e.response && e.response.status === 404) {
          this.$message.error(`La cámara ${identifier} no existe`);
        } else {
          this.$message.error(`Error al refrescar la cámara ${identifier}`);
        }
      } finally {
        this.refreshingId = null;
      }
    },
  },
};
</script>

<style scoped>
.axd-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: #f0f4f8;
}

.axd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 18px 24px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.axd-header__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
}

.axd-header__stats {
  display: flex;
  align-items: center;
  gap: 18px;
}

.axd-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.axd-stat__value {
  font-size: 18px;
  font-weight: 700;
  color: #0284c7;
}

.axd-stat--danger .axd-stat__value {
  color: #ef4444;
}
.axd-stat--warning .axd-stat__value {
  color: #f59e0b;
}

.axd-stat__label {
  font-size: 10px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.axd-body {
  flex: 1;
  overflow: auto;
  padding: 22px 24px;
}

.axd-empty {
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  padding: 60px 0;
}

.axd-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 14px;
}
</style>
